var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStackedViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5H15V2.5C14.9996 2.16861 14.8678 1.8509 14.6334 1.61657C14.3991 1.38224 14.0814 1.25041 13.75 1.25H2.5C2.16861 1.25041 1.8509 1.38224 1.61657 1.61657C1.38224 1.8509 1.25041 2.16861 1.25 2.5V13.75C1.25041 14.0814 1.38224 14.3991 1.61657 14.6334C1.8509 14.8678 2.16861 14.9996 2.5 15H5V17.5C5.00041 17.8314 5.13224 18.1491 5.36657 18.3834C5.6009 18.6178 5.91861 18.7496 6.25 18.75H17.5C17.8314 18.7496 18.1491 18.6178 18.3834 18.3834C18.6178 18.1491 18.7496 17.8314 18.75 17.5V6.25C18.7496 5.91861 18.6178 5.6009 18.3834 5.36657C18.1491 5.13224 17.8314 5.00041 17.5 5ZM13.75 13.75H8.75V10.625H13.75V13.75ZM13.75 9.375H8.75V6.25H13.75V9.375ZM7.5 9.375H2.5V6.25H7.5V9.375ZM13.75 2.5V5H2.5V2.5H13.75ZM2.5 13.75V10.625H7.5V13.75H2.5ZM17.5 17.5H6.25V15H13.75C14.0814 14.9996 14.3991 14.8678 14.6334 14.6334C14.8678 14.3991 14.9996 14.0814 15 13.75V6.25H17.5V17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStackedViews);
export default __webpack_public_path__ + "static/media/ic-stacked-views.4aa3178166c5882f7d42ec21c41f2a10.svg";
export { ForwardRef as ReactComponent };